import { render } from "./DeviceModelsList.vue?vue&type=template&id=2f6f9a93&scoped=true"
import script from "./DeviceModelsList.vue?vue&type=script&lang=js"
export * from "./DeviceModelsList.vue?vue&type=script&lang=js"

import "./DeviceModelsList.vue?vue&type=style&index=0&id=2f6f9a93&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f6f9a93"]])

export default __exports__